import { render } from "./InputLabel.vue?vue&type=template&id=68b2b041"
import script from "./InputLabel.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InputLabel.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__